module.exports = __webpack_public_path__ + "img/OverseaMember52.c9251d7c.jpg";